function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 7c-.737 0-1.375.405-1.722 1H8.5C6.642 8 5.132 6.54 5.021 4.71 5.605 4.361 6 3.728 6 3c0-1.103-.897-2-2-2s-2 .897-2 2c0 .737.405 1.375 1 1.722v6.556c-.595.347-1 .985-1 1.722 0 1.103.897 2 2 2s2-.897 2-2c0-.737-.405-1.375-1-1.722V8.739A5.477 5.477 0 008.5 10h1.778c.347.595.985 1 1.722 1 1.103 0 2-.897 2-2s-.897-2-2-2zM4 2c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1zm0 12a1.001 1.001 0 010-2 1.001 1.001 0 010 2zm8-4a1 1 0 110-2 1 1 0 010 2z"
});

function SvgMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 20"
  }, props), _ref);
}

export default SvgMerge;